import { t } from 'ember-intl';
import { LayoutSidebarSubnav } from 'core/components';

<template>
  <LayoutSidebarSubnav as |Subnav|>
    <Subnav.BackLink
      @text={{t
        "components.page.access-control.groups.detail.subnav.title.back"
      }}
      @route="cloud.access-control.groups.list"
    />
    <Subnav.Title>
      {{@model.group.displayName}}
    </Subnav.Title>
    {{#if @model.isProjectContext}}
      <Subnav.Link
        @current-when="cloud.access-control.groups.detail.index cloud.access-control.groups.detail.edit"
        @text={{t "components.page.access-control.groups.detail.title.heading"}}
        @route="cloud.access-control.groups.detail.index"
      />
      <Subnav.Link
        @text={{t "components.page.access-control.groups.detail.members.title"}}
        @route="cloud.access-control.groups.detail.members.index"
      />
    {{else}}
      <Subnav.Link
        @text={{t "components.page.access-control.groups.detail.title.heading"}}
        @route="cloud.access-control.groups.detail"
      />
    {{/if}}
  </LayoutSidebarSubnav>
  {{outlet}}
</template>
